'use strict';
import React from 'react';
import Sticky from 'react-stickynode';

export default class CheckoutTotals extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enabled: true
        };
    }
    getWindowDimensions() {
        var w = window;
        var d = document;
        var e = d.documentElement;
        var g = d.getElementsByTagName('body')[0];
        var x = w.innerWidth || e.clientWidth || g.clientWidth;
        var y = w.innerHeight || e.clientHeight || g.clientHeight;
        return {x,y};
    }
    onResize = () => {
        let {x,y} = this.getWindowDimensions();
        this.setState({enabled: x > 1019});
    };
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }
    componentDidMount() {
        window.addEventListener('resize', this.onResize, true);
        this.onResize();
    }
    render() {
        let products = this.props.cart.getIn(['totals', 'products']).toJS();
        let total = this.props.cart.getIn(['totals', this.props.cart.get('selected_payment')]).toJS();
        let payment = this.props.cart.getIn(['payment', this.props.cart.get('selected_payment')]).toJS();
        return (
            <Sticky enabled={this.state.enabled} top={50} bottomBoundary={1500}>
                <div ref="totals" className="checkout__totals">
                    <div className="totals__headline">Gesamt</div>
                    <div className="totals__sums">
                        <div className="sums__products">
                            Zwischensumme: {products.formatted}
                        </div>
                        <div className="sums__shipping">
                            Versandkosten: {payment.formatted}
                        </div>
                        <div className="sums__tax">
                            Enthaltene 19% Mwst: {total.tax}
                        </div>
                    </div>
                    <div className="totals__total">
                        Gesamtsumme: {total.formatted}
                    </div>
                </div>
            </Sticky>
        );
    }
}




// WEBPACK FOOTER //
// ./static/app/checkout/steps/checkoutTotals.jsx